import { useEffect, useMemo, useState } from "react";

import { Box, Button, Card, Checkbox, Collapse, Fade, Grid, IconButton, Stack, Typography } from "@mui/material";
import FullscreenIcon from "@mui/icons-material/Fullscreen";
import FullscreenExitIcon from "@mui/icons-material/FullscreenExit";
import CloseIcon from "@mui/icons-material/Close";
import KeyboardDoubleArrowDownIcon from "@mui/icons-material/KeyboardDoubleArrowDown";
import Image from "Assets/Images/Login/image.png";
import { starDashboardZoneLinkCreater, starDashboardStationLinkCreater, starDashboardPathLinkCreater } from "Helper/sidebar";

import { DESTINATION, LAYOUT_MARGIN, SOURCE } from "Configs/home";
import { OperationNames } from "Types/operation";

import useCancelOperation from "Hooks/useCancelOperation";
import { useAppDispatch, useAppSelector } from "Hooks/useRedux";
import useWindowSize from "Hooks/useWindowSize";

import { deselectPath, toggleFullScreen } from "Redux/servicesSlice";
import { setMinimize } from "Redux/mapSlice";
import { deselectStation } from "Redux/stationsSlice";
import destinationSvg from "Assets/Images/Survey/destination-icon.svg";
import usePaths from "Hooks/usePaths";
import useEditPath from "Hooks/useEditPath";

// const starBaseUrl = process.env.REACT_STAR_BASE_URL;

// Doesn't look good but it works :(
const SIZES: { [key: string]: number } = {
  operationBoxHeight: 56,
  marginTop: 8,
  toolsBoxHeight: 56,
  marginBottom: 8,
  topContent: 70,
  bottomContent: 56,
  bottomContentMargin: 16,
};

export default function SimpleDashboard() {
  const dispatch = useAppDispatch();
  const [starLink1, setStarLink1] = useState<string>();
  const [starLink2, setStarLink2] = useState<string>();
  const [openStar, setOpenStar] = useState<boolean>();
  const [openStar2, setOpenStar2] = useState<boolean>();
  const { path } = useAppSelector((state) => state.app);
  const { source, applySelecteds, autoApply, destination } = useAppSelector((state) => state.zones);
  const { stations, visibleStationDashboard, starStation } = useAppSelector((state) => state.stations);
  const { visible, deselectedPathes, starDashboardVisible, fullScreen } = useAppSelector((state) => state.services);
  const { showSupportLeftSide } = useAppSelector((state) => state.side);
  const { trafficAnalysisStarUrl } = useAppSelector((state) => state.star);

  const data = usePaths();

  const { height } = useWindowSize();

  const { cancelOperation } = useCancelOperation();

  const [isOpen, setIsOpen] = useState<boolean>(true);

  const operationNames: OperationNames[] = ["create-path", "edit-path"];

  const toggleCollapse = () => setIsOpen((prev) => !prev);

  const handleScreenSize = () => {
    dispatch(toggleFullScreen());
  };

  const makeFullScreenSize = () => {
    if (!fullScreen) {
      dispatch(toggleFullScreen());
    }
  };

  const boxHeight = useMemo(() => {
    let result = 0;
    Object.keys(SIZES).forEach((key) => {
      result += SIZES[key];
    });
    return `${height - (result + LAYOUT_MARGIN * 2) + 12}px`;
  }, [height]);

  useEffect(() => {
    if (source.length > 0 || destination.length > 0) {
      if (!openStar2) {
        if (applySelecteds || autoApply) {
          setOpenStar2(true);
          const { sideDashLink, extendDashLink } = starDashboardZoneLinkCreater(source, destination);
          setStarLink1(extendDashLink);
          setStarLink2(sideDashLink);
        }
      }
    }

    if (openStar2) {
      const { sideDashLink, extendDashLink } = starDashboardZoneLinkCreater(source, destination);
      setStarLink1(extendDashLink);
      setStarLink2(sideDashLink);
    }
  }, [autoApply, applySelecteds, source, destination]);

  useEffect(() => {
    if (starDashboardVisible || visibleStationDashboard) {
      setOpenStar(true);
    } else {
      setOpenStar(false);
    }
  }, [starDashboardVisible, visibleStationDashboard]);

  useEffect(() => {
    if (visibleStationDashboard) {
      const { sideDashLink, extendDashLink } = starDashboardStationLinkCreater(path?.code, starStation?.code);
      setStarLink1(extendDashLink);
      setStarLink2(sideDashLink);
    } else {
      const { sideDashLink, extendDashLink } = starDashboardPathLinkCreater(path?.code);
      setStarLink1(extendDashLink);
      setStarLink2(sideDashLink);
    }
  }, [visibleStationDashboard, starDashboardVisible, starStation, path]);

  return (
    <Fade in={openStar || openStar2 || showSupportLeftSide} mountOnEnter unmountOnExit>
      <Card sx={{ mt: 1, p: fullScreen ? "2vw" : "1vw", width: "100%", boxShadow: 3, paddingTop: "8px" }}>
        <Stack direction="row" sx={{ justifyContent: "space-between" }}>
          <Button sx={{ width: "30px", minWidth: "0" }} onClick={handleScreenSize}>
            {fullScreen ? <FullscreenExitIcon /> : <FullscreenIcon />}
          </Button>
          {!fullScreen ? (
            <Button
              startIcon={
                <KeyboardDoubleArrowDownIcon sx={{ transform: isOpen ? "rotate(180deg)" : "", transition: "all 0.3s" }} />
              }
              sx={{ minWidth: "100px" }}
              onClick={toggleCollapse}
            >
              {isOpen ? "بستن" : "بازکردن"}
            </Button>
          ) : null}
        </Stack>

        <Collapse in={isOpen}>
          <iframe
            src={fullScreen ? starLink1 : starLink2}
            title="star-dashboard"
            style={{
              width: fullScreen ? "94vw" : "100%",
              height: fullScreen ? "85vh" : boxHeight,
              transition: "all 0.3s",
              border: "none",
            }}
            onError={() => {}}
          />
          <Stack>
            {!fullScreen ? (
              <Button
                variant="contained"
                sx={{ textAlign: "center", margin: "auto", justifyContent: "center" }}
                onClick={makeFullScreenSize}
              >
                مشاهده جزییات
              </Button>
            ) : null}
          </Stack>
        </Collapse>
      </Card>
    </Fade>
  );
}
